// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScopeFilterGroup-module__root___sBmql {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.ScopeFilterGroup-module__chipRoot___i595J {
  position: relative;
}

.ScopeFilterGroup-module__chipTrigger___TT_O2 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  font-size: 13px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #18181b;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
}
.ScopeFilterGroup-module__chipTrigger___TT_O2:hover {
  background: #f4f4f5;
  border-color: #d4d4d8;
}
.ScopeFilterGroup-module__chipTrigger___TT_O2:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ScopeFilterGroup-module__chipLabel___sC0iC {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  color: #a1a1aa;
}

.ScopeFilterGroup-module__chipValue___OJhEL {
  max-width: 9rem;
  overflow-x: hidden;
  overflow-y: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
  font-weight: 600;
  color: #18181b;
}

.ScopeFilterGroup-module__chipAll___IO_P4 {
  line-height: 1.4;
  color: #71717a;
}

.ScopeFilterGroup-module__chipBadge___LSKNB {
  padding: 1px 5px;
  font-size: 11px;
  font-weight: 600;
  color: #52525b;
  background: #e4e4e7;
  border-radius: 3px;
}

.ScopeFilterGroup-module__chevron___lsdOs {
  color: #a1a1aa;
  flex-shrink: 0;
}

.ScopeFilterGroup-module__dropdown___eP6QF {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 50;
  min-width: 200px;
  max-height: 320px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 4px;
}

.ScopeFilterGroup-module__optionDivider___lrDkR {
  height: 1px;
  margin: 4px 2px;
  background: #f0f0f1;
}

.ScopeFilterGroup-module__option___EjWQc {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;
}
.ScopeFilterGroup-module__option___EjWQc:hover {
  background: #f4f4f5;
}

.ScopeFilterGroup-module__optionCheck___MJpvr {
  color: #18181b;
  flex-shrink: 0;
}

.ScopeFilterGroup-module__optionLabel___p_zuH {
  flex: 1;
  overflow-x: hidden;
  overflow-y: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.ScopeFilterGroup-module__optionTone___UwmNC {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.ScopeFilterGroup-module__optionTone___UwmNC[data-tone=green] {
  background: #86efac;
}
.ScopeFilterGroup-module__optionTone___UwmNC[data-tone=yellow] {
  background: #facc15;
}
.ScopeFilterGroup-module__optionTone___UwmNC[data-tone=orange] {
  background: #fdba74;
}
.ScopeFilterGroup-module__optionTone___UwmNC[data-tone=red] {
  background: #fca5a5;
}

.ScopeFilterGroup-module__guideToggle___q1plk {
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
}
.ScopeFilterGroup-module__guideToggle___q1plk:hover {
  background: #f4f4f5;
  border-color: #d4d4d8;
}

.ScopeFilterGroup-module__guideToggleActive___Dh2Kz {
  color: #ffffff;
  background: #4338ca;
  border-color: #4338ca;
}
.ScopeFilterGroup-module__guideToggleActive___Dh2Kz:hover {
  background: #3730a3;
}

.ScopeFilterGroup-module__divider___eg4mZ {
  width: 1px;
  height: 24px;
  background: #e4e4e7;
  flex-shrink: 0;
}

.ScopeFilterGroup-module__utilities___SBJ9P {
  display: flex;
  align-items: center;
  gap: 2px;
}

.ScopeFilterGroup-module__utilityButton___TyzkE {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  color: #a1a1aa;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.ScopeFilterGroup-module__utilityButton___TyzkE svg {
  display: block;
}
.ScopeFilterGroup-module__utilityButton___TyzkE:hover {
  color: #3f3f46;
  background: #f4f4f5;
}
.ScopeFilterGroup-module__utilityButton___TyzkE:focus-visible {
  outline: 2px solid #d4d4d8;
  outline-offset: 1px;
}

.ScopeFilterGroup-module__utilityButtonPinned___slPlf {
  color: #71717a;
}

.ScopeFilterGroup-module__utilityButtonPaused___sQ7_7 {
  color: #b45309;
  background: #fef3c7;
}
.ScopeFilterGroup-module__utilityButtonPaused___sQ7_7:hover {
  color: #92400e;
  background: #fde68a;
}

.ScopeFilterGroup-module__resetButton___RZjqi {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 500;
  color: #a1a1aa;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.ScopeFilterGroup-module__resetButton___RZjqi svg {
  display: block;
}
.ScopeFilterGroup-module__resetButton___RZjqi:hover {
  color: #3f3f46;
  background: #f4f4f5;
}
.ScopeFilterGroup-module__resetButton___RZjqi:focus-visible {
  outline: 2px solid #d4d4d8;
  outline-offset: 1px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ScopeFilterGroup/ScopeFilterGroup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;EACA,qBAAA;AACJ;AAEE;EACE,0BAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,OAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AANF;AAQE;EACE,mBAAA;EACA,qBAAA;AANJ;;AAUA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mDACE;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,cAAA;EACA,mBAAA;AAXJ;AAcE;EACE,0BAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,cAAA;EACA,mBAAA;AAbF;AAeE;EACE,cAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAdF;AAgBE;EACE,cAAA;AAdJ;AAiBE;EACE,cAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,0BAAA;EACA,mBAAA;AAhBJ","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.chipRoot {\n  position: relative;\n}\n\n.chipTrigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 10px;\n  font-size: 13px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #18181b;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1;\n\n  &:hover {\n    background: #f4f4f5;\n    border-color: #d4d4d8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #18181b;\n    outline-offset: 2px;\n  }\n}\n\n.chipLabel {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #a1a1aa;\n}\n\n.chipValue {\n  max-width: 9rem;\n  overflow-x: hidden;\n  overflow-y: visible;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.4;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.chipAll {\n  line-height: 1.4;\n  color: #71717a;\n}\n\n.chipBadge {\n  padding: 1px 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #52525b;\n  background: #e4e4e7;\n  border-radius: 3px;\n}\n\n.chevron {\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 50;\n  min-width: 200px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 4px;\n}\n\n.optionDivider {\n  height: 1px;\n  margin: 4px 2px;\n  background: #f0f0f1;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 7px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  background: transparent;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: #f4f4f5;\n  }\n}\n\n.optionCheck {\n  color: #18181b;\n  flex-shrink: 0;\n}\n\n.optionLabel {\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: visible;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.optionTone {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n\n  &[data-tone='green'] {\n    background: #86efac;\n  }\n\n  &[data-tone='yellow'] {\n    background: #facc15;\n  }\n\n  &[data-tone='orange'] {\n    background: #fdba74;\n  }\n\n  &[data-tone='red'] {\n    background: #fca5a5;\n  }\n}\n\n.guideToggle {\n  padding: 7px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #18181b;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 1;\n\n  &:hover {\n    background: #f4f4f5;\n    border-color: #d4d4d8;\n  }\n}\n\n.guideToggleActive {\n  color: #ffffff;\n  background: #4338ca;\n  border-color: #4338ca;\n\n  &:hover {\n    background: #3730a3;\n  }\n}\n\n.divider {\n  width: 1px;\n  height: 24px;\n  background: #e4e4e7;\n  flex-shrink: 0;\n}\n\n.utilities {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.utilityButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  color: #a1a1aa;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n\n  svg {\n    display: block;\n  }\n\n  &:hover {\n    color: #3f3f46;\n    background: #f4f4f5;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #d4d4d8;\n    outline-offset: 1px;\n  }\n}\n\n.utilityButtonPinned {\n  color: #71717a;\n}\n\n.utilityButtonPaused {\n  color: #b45309;\n  background: #fef3c7;\n\n  &:hover {\n    color: #92400e;\n    background: #fde68a;\n  }\n}\n\n.resetButton {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #a1a1aa;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n\n  svg {\n    display: block;\n  }\n\n  &:hover {\n    color: #3f3f46;\n    background: #f4f4f5;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #d4d4d8;\n    outline-offset: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ScopeFilterGroup-module__root___sBmql`,
	"chipRoot": `ScopeFilterGroup-module__chipRoot___i595J`,
	"chipTrigger": `ScopeFilterGroup-module__chipTrigger___TT_O2`,
	"chipLabel": `ScopeFilterGroup-module__chipLabel___sC0iC`,
	"chipValue": `ScopeFilterGroup-module__chipValue___OJhEL`,
	"chipAll": `ScopeFilterGroup-module__chipAll___IO_P4`,
	"chipBadge": `ScopeFilterGroup-module__chipBadge___LSKNB`,
	"chevron": `ScopeFilterGroup-module__chevron___lsdOs`,
	"dropdown": `ScopeFilterGroup-module__dropdown___eP6QF`,
	"optionDivider": `ScopeFilterGroup-module__optionDivider___lrDkR`,
	"option": `ScopeFilterGroup-module__option___EjWQc`,
	"optionCheck": `ScopeFilterGroup-module__optionCheck___MJpvr`,
	"optionLabel": `ScopeFilterGroup-module__optionLabel___p_zuH`,
	"optionTone": `ScopeFilterGroup-module__optionTone___UwmNC`,
	"guideToggle": `ScopeFilterGroup-module__guideToggle___q1plk`,
	"guideToggleActive": `ScopeFilterGroup-module__guideToggleActive___Dh2Kz`,
	"divider": `ScopeFilterGroup-module__divider___eg4mZ`,
	"utilities": `ScopeFilterGroup-module__utilities___SBJ9P`,
	"utilityButton": `ScopeFilterGroup-module__utilityButton___TyzkE`,
	"utilityButtonPinned": `ScopeFilterGroup-module__utilityButtonPinned___slPlf`,
	"utilityButtonPaused": `ScopeFilterGroup-module__utilityButtonPaused___sQ7_7`,
	"resetButton": `ScopeFilterGroup-module__resetButton___RZjqi`
};
module.exports = ___CSS_LOADER_EXPORT___;
